function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchFieldContext } from './SearchField';
import Loading from './utils/Loading';
import Error from './utils/Error';
import './SearchAgent.scss';

var SearchResultItem = function SearchResultItem(_ref) {
  var item = _ref.item,
      onSelect = _ref.onSelect;
  var title = item.title,
      desc = item.desc;
  return /*#__PURE__*/React.createElement("div", {
    className: "search-result-item",
    onClick: function onClick() {
      return onSelect(item);
    },
    onMouseOver: function onMouseOver() {
      return item.olFeature && item.olFeature.set('hover', true);
    },
    onMouseOut: function onMouseOut() {
      return item.olFeature && item.olFeature.set('hover', false);
    }
  }, /*#__PURE__*/React.createElement("h4", null, title), desc && /*#__PURE__*/React.createElement("div", {
    className: "search-result-item--description"
  }, desc));
};

SearchResultItem.propTypes = process.env.NODE_ENV !== "production" ? {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string
  }),
  onSelect: PropTypes.func
} : {};
/**
 * Search agent that utilizes any compatible search function and renders
 * its state and results.
 *
 * @example ./SearchAgent.functions.md
 */

var SearchAgent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchAgent, _Component);

  function SearchAgent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false,
      expanded: false,
      error: null,
      items: [],
      total: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (item) {
      var onItemSelect = _this.context.onItemSelect;
      var onSelect = _this.props.onSelect;
      onItemSelect(item);
      onSelect && onSelect(item);
    });

    return _this;
  }

  var _proto = SearchAgent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var query = this.context.query;

    if (query) {
      this.query(query);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var query = this.context.query;

    if (query !== this.state.query) {
      this.query(query);
    }
  };

  _proto.componentWillMount = function componentWillMount() {
    if (this.currentRequest) {
      this.currentRequest.cancel();
    }
  };

  _proto.query = function query(_query) {
    var _this2 = this;

    var _this$context = this.context,
        bbox = _this$context.bbox,
        onResults = _this$context.onResults;
    this.setState({
      loading: true,
      error: null,
      query: _query
    });

    if (this.currentRequest) {
      this.currentRequest.cancel();
    }

    this.currentRequest = this.props.searchFunction(_query, bbox, function (err, items, total) {
      onResults(items);

      _this2.setState({
        loading: false,
        items: items,
        total: total,
        error: err && err.toString()
      });
    });
  };

  _proto.renderResult = function renderResult() {
    var _this3 = this;

    var renderItems = this.state.items;
    var expanded = this.state.expanded;
    var _this$props = this.props,
        ItemComponent = _this$props.itemComponent,
        minItems = _this$props.minItems,
        emptyText = _this$props.emptyText;

    if (!renderItems || renderItems.length === 0) {
      return emptyText && /*#__PURE__*/React.createElement("span", {
        className: "search-agent--empty"
      }, emptyText);
    }

    if (!expanded) {
      renderItems = renderItems.slice(0, minItems);
    }

    return renderItems.map(function (item) {
      return /*#__PURE__*/React.createElement(ItemComponent, {
        key: item.uid,
        item: item,
        onSelect: _this3.onSelect
      });
    });
  };

  _proto.renderState = function renderState() {
    var _this$state = this.state,
        loading = _this$state.loading,
        error = _this$state.error;
    var _this$props2 = this.props,
        Loading = _this$props2.loadingComponent,
        Error = _this$props2.errorComponent;

    if (loading) {
      return /*#__PURE__*/React.createElement(Loading, null);
    }

    if (error) {
      return /*#__PURE__*/React.createElement(Error, {
        error: error
      });
    }

    return this.renderResult();
  };

  _proto.renderMoreToggle = function renderMoreToggle() {
    var _this4 = this;

    var _this$state2 = this.state,
        loading = _this$state2.loading,
        expanded = _this$state2.expanded;
    var _this$props3 = this.props,
        showLessText = _this$props3.showLessText,
        showMoreText = _this$props3.showMoreText;
    var _this$context2 = this.context,
        contextShowLessText = _this$context2.showLessText,
        contextShowMoreText = _this$context2.showMoreText;
    return !loading && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "search-agent--toggle",
      onClick: function onClick(e) {
        e.preventDefault();

        _this4.setState(function (state) {
          return {
            expanded: !state.expanded
          };
        });
      }
    }, expanded ? showLessText || contextShowLessText : showMoreText || contextShowMoreText);
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        className = _this$props4.className,
        title = _this$props4.title,
        minItems = _this$props4.minItems;
    var _this$state3 = this.state,
        loading = _this$state3.loading,
        total = _this$state3.total;
    var showResults = this.context.showResults;
    if (!showResults) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: 'search-agent ' + className + (!loading && !total ? ' empty' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-agent--header"
    }, /*#__PURE__*/React.createElement("h3", null, title, ' ', !loading && total !== undefined ? /*#__PURE__*/React.createElement("span", {
      className: "total"
    }, "(", total === 1000 ? '>1000' : total, ")") : ''), !!total && total > minItems && this.renderMoreToggle()), /*#__PURE__*/React.createElement("div", {
      className: "search-agent--state"
    }, this.renderState()));
  };

  return SearchAgent;
}(Component);

_defineProperty(SearchAgent, "contextType", SearchFieldContext);

_defineProperty(SearchAgent, "defaultProps", {
  className: '',
  errorComponent: Error,
  itemComponent: SearchResultItem,
  loadingComponent: Loading,
  minItems: 4
});

export { SearchAgent as default };
SearchAgent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Additional class name for this search agent.
   */
  className: PropTypes.string,

  /**
   * Title of search agent.
   */
  title: PropTypes.string,

  /**
   * Text to render when no results are found. Keep unset to render nothing.
   */
  emptyText: PropTypes.string,

  /**
   * The component rendered when an error has occurred.
   */
  errorComponent: PropTypes.func,

  /**
   * The component rendered per result item. Must accept props `item` object and `onSelect` function.
   */
  itemComponent: PropTypes.func,

  /**
   * The component rendered as a loading indicator.
   */
  loadingComponent: PropTypes.func,

  /**
   * The number of items to show when not expanded.
   */
  minItems: PropTypes.number,

  /**
   * A function with signature (query:string, bbox:string, callback:function(err:Error, items:Array, total:Number)).
   *
   * When query is changed, this function is called to perform request towards the search API. See below for available functions.
   */
  searchFunction: PropTypes.func.isRequired,

  /**
   * Callback when an item is selected. Can be used to handle specific agents' items instead of using `onItemSelect` on `SearchField`.
   */
  onSelect: PropTypes.func,

  /**
   * Label for show more toggle. Uses prop inherited from `SearchField` by default.
   */
  showMoreText: PropTypes.string,

  /**
   * Label for show less toggle. Uses prop inherited from `SearchField` by default.
   */
  showLessText: PropTypes.string
} : {};